import {
    QUESTIONS_DATA_FETCHED,
    UPDATE_QUESTION_FORM_DATA,
    UPDATE_SUBS_MENTIONS_FLAG,
    INIT_QUESTION_DATA,
    QUESTIONS_DATA_SEND,
    HANDLE_ASK_QUESTION_POPIN
} from '../actionsTypes'

const initialState = {
    content: '',
    pseudo: '',
    email: '',
    subsMentions: 0,
    successSend: true,
    message: '',
    pageIndex : 2,
    items: [],
    changeQuestionsFromClient : false ,
    summary: '',
    openPopin: false

};


const QuestionsReducer = (state = initialState, action) => {

    switch (action.type) {
        case QUESTIONS_DATA_FETCHED:
            return {
                ...state,
                pageIndex : state.pageIndex + 1,
                summary : action.payload.summary,
                items :  [...action.payload.reviewQuestionsItems, ...action.payload.items],
                changeQuestionsFromClient :action.payload.changeQuestionsFromClient
            }
        case UPDATE_QUESTION_FORM_DATA:
            let actionElementName = action.element.name;
            let questionFormState = {...state};
            questionFormState[actionElementName] = action.element.value;
            return questionFormState;
        case UPDATE_SUBS_MENTIONS_FLAG:
            return {
                ...state,
                subsMentions: (state.subsMentions == 0) ? 1 : 0
            }

        case INIT_QUESTION_DATA:
            return {
                ...state,
                content: '',
                pseudo: '',
                email: '',
                subsMentions: 0,
                successSend: true,
                message: ''
            }
        case QUESTIONS_DATA_SEND:
            return {
                ...state,
                successSend: action.payload.success,
                message: action.payload.message,
            }
        case HANDLE_ASK_QUESTION_POPIN:
            return {
                ...state,
                openPopin: action.payload.openPopin
            }
        default:
            return state;
    }

};

export default QuestionsReducer;